import { useEffect, useState } from "react";
import { api, euro, fileUrl, formatDate, formatMonth } from "@/lib/api";
import { Eye, FileText } from "lucide-react";
import DocumentPreview from "@/components/DocumentPreview";

export default function BustePagaMaestra() {
  const [buste, setBuste] = useState([]);
  const [loading, setLoading] = useState(true);
  const [preview, setPreview] = useState(null);
  const payslipName = (busta) => {
    const period = formatMonth(busta.mese); const ext = (busta.documento_nome?.split(".").pop() || "pdf").toLowerCase();
    return `${period.charAt(0).toUpperCase()}${period.slice(1)}.${ext}`;
  };

  useEffect(() => {
    api.get("/maestra/buste-paga").then(({data}) => setBuste(data)).catch(() => setBuste([])).finally(() => setLoading(false));
  }, []);

  return <div className="space-y-6 animate-fade-up" data-testid="maestra-buste-page">
    <div><h1 className="font-heading text-4xl font-semibold text-[#3D405B] tracking-tight">Buste paga</h1><p className="text-[#6C757D] mt-1 text-sm">Consulta e scarica le buste paga inviate dall’amministrazione.</p></div>
    {loading ? <div className="card-warm p-10 text-center text-[#a89a8a]">Caricamento...</div> : !buste.length ? <div className="card-warm p-10 text-center"><FileText className="w-10 h-10 mx-auto text-[#a89a8a] mb-3"/><p className="text-[#6C757D]">Nessuna busta paga è stata ancora inviata.</p></div> : <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
      {buste.map((busta)=><div key={busta.id} className="card-warm p-5 flex flex-col gap-4">
        <div className="flex items-start justify-between gap-3"><div><p className="label-warm">Periodo</p><h2 className="font-heading text-xl font-semibold capitalize text-[#3D405B]">{formatMonth(busta.mese)}</h2></div><FileText className="w-6 h-6 text-[#E07A5F]"/></div>
        <div className="rounded-xl bg-[#FAF6F0] p-4"><p className="text-xs text-[#6C757D]">Netto</p><p className="text-2xl font-bold text-[#3D405B]">{euro(busta.netto)}</p>{busta.pagata&&<p className="text-xs font-semibold text-[#4a7a63] mt-1">Pagata il {formatDate(busta.data_pagamento)}</p>}</div>
        <button type="button" onClick={()=>setPreview({url:fileUrl(busta.documento_path),title:`Busta paga · ${formatMonth(busta.mese)}`,fileName:payslipName(busta)})} className="btn-sage w-full"><Eye className="w-4 h-4"/> Anteprima</button>
      </div>)}
    </div>}
    <DocumentPreview document={preview} onClose={()=>setPreview(null)}/>
  </div>;
}
